module.exports = __webpack_public_path__ + "2-48.jpg?dd7401d7eb2533bce86626fc8f054aa5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-48.jpg
// module id = 125
// module chunks = 0